






import RootComponent from "@/components/rootcomponent/RootComponent";
export default RootComponent;
